import initialState from './initialState';
import {
  POLYNOMIAL_ADMIN_GET_LIST_INIT,
  POLYNOMIAL_ADMIN_GET_LIST_SUCCESS,
  POLYNOMIAL_ADMIN_GET_LIST_FAILURE,
  POLYNOMIAL_ADMIN_SAVE_INIT,
  POLYNOMIAL_ADMIN_SAVE_SUCCESS,
  POLYNOMIAL_ADMIN_SAVE_FAILURE,
  POLYNOMIAL_ADMIN_SET_SAVE_DATA_BY_KEY,
  POLYNOMIAL_ADMIN_SAVE_RESET,
  POLYNOMIAL_ADMIN_DELETE_PREPARE_INIT,
  POLYNOMIAL_ADMIN_DELETE_INIT,
  POLYNOMIAL_ADMIN_DELETE_SUCCESS,
  POLYNOMIAL_ADMIN_DELETE_FAILURE,
  POLYNOMIAL_ADMIN_DELETE_VERSION_INIT,
  POLYNOMIAL_ADMIN_DELETE_VERSION_PREPARE_INIT,
  POLYNOMIAL_ADMIN_DELETE_VERSION_SUCCESS,
  POLYNOMIAL_ADMIN_DELETE_VERSION_FAILURE,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_INIT,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_SUCCESS,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_FAILURE,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_INIT,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_SUCCESS,
  POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_FAILURE,  
  POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_INIT,
  POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_SUCCESS,
  POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_FAILURE,
  POLYNOMIAL_ADMIN_GET_TAGS_LIST_INIT,
  POLYNOMIAL_ADMIN_GET_TAGS_LIST_SUCCESS,
  POLYNOMIAL_ADMIN_GET_TAGS_LIST_FAILURE,
  POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_INIT,
  POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_SUCCESS,
  POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_FAILURE,
  POLYNOMIAL_ADMIN_RESET
} from '../../actions/polynomialAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';

export default function polynomialAdmin(state = initialState, action) {
  switch (action.type) {      
    case POLYNOMIAL_ADMIN_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case POLYNOMIAL_ADMIN_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case POLYNOMIAL_ADMIN_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
    case POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "dimensionsList");
    case POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "dimensionsList");
    case POLYNOMIAL_ADMIN_GET_DIMENSIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "dimensionsList");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "preloadPolynomial");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "preloadPolynomial");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "preloadPolynomial");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "polynomialVersion");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "polynomialVersion");
    case POLYNOMIAL_ADMIN_GET_POLYNOMIAL_VERSION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "polynomialVersion");
    case POLYNOMIAL_ADMIN_SAVE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "save");
    case POLYNOMIAL_ADMIN_SAVE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "save");
    case POLYNOMIAL_ADMIN_SAVE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "save");
    case POLYNOMIAL_ADMIN_SET_SAVE_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "save");
    case POLYNOMIAL_ADMIN_SAVE_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "save");
    case POLYNOMIAL_ADMIN_DELETE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "delete");
    case POLYNOMIAL_ADMIN_DELETE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "delete");
    case POLYNOMIAL_ADMIN_DELETE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "delete");
    case POLYNOMIAL_ADMIN_DELETE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "delete");
    case POLYNOMIAL_ADMIN_DELETE_VERSION_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deleteVersion");
    case POLYNOMIAL_ADMIN_DELETE_VERSION_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deleteVersion");
    case POLYNOMIAL_ADMIN_DELETE_VERSION_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deleteVersion");
    case POLYNOMIAL_ADMIN_DELETE_VERSION_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deleteVersion");
    case POLYNOMIAL_ADMIN_GET_TAGS_LIST_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "tagsList");
    case POLYNOMIAL_ADMIN_GET_TAGS_LIST_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "tagsList");
    case POLYNOMIAL_ADMIN_GET_TAGS_LIST_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "tagsList");
    case POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "restorePolynomialVersion");
    case POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "restorePolynomialVersion");
    case POLYNOMIAL_ADMIN_RESTORE_POLYNOMIAL_VERSION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "restorePolynomialVersion");
    case POLYNOMIAL_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/polynomialAdmin/index.js